module.exports = __webpack_public_path__ + "media/icons/website-57490e60.svg";